export const PRODUCTS_SEARCH_CONTEXT = {
  PRODUCTS_RELATED: 'products_related',
  PRODUCTS_SEARCH_DEFAULT: 'products_search_default',
  PRODUCTS_SEARCH: 'products_search',
  SEARCH_BAR_EDITABLE: 'search_bar_editable',
  SEARCH_BAR_ENJOEIPRO: 'search_bar_enjoeipro',
  SEARCH_BAR_RECENT: 'search_bar_recent',
  SEARCH_BRAND_FOOTER: 'search_brand_footer',
  SEARCH_BRAND_MENU: 'search_brand_menu',
  SEARCH_BRAND_PRODUCT_PAGE: 'search_brand_product_page',
  SEARCH_CATEGORIES_FOOTER: 'search_categories_footer',
  SEARCH_CATEGORIES_MENU: 'search_categories_menu',
  SEARCH_CATEGORIES_PRODUCT_PAGE: 'search_categories_product_page',
  SEARCH_DEPARTMENT_FOOTER: 'search_department_footer',
  SEARCH_DEPARTMENT_MENU: 'search_department_menu',
  SEARCH_DEPARTMENT_PRODUCT_PAGE: 'search_department_product_page',
  SEARCH_FEATURED_MENU: 'search_featured_menu',
  STORE_RELATED: 'store_related',
  STORE_SEARCH: 'store_search',
  WELCOME_HOME_CATEGORIES: 'welcome_home_categories',
  WELCOME_HOME_DEPARTMENTS: 'welcome_home_departments',
  WELCOME_HOME_EXPLORE_BRANDS: 'welcome_home_explore_brands',
  WELCOME_HOME_BRAND: 'welcome_home_brand',
  ENJOEI_PRO: 'home_enjoeipro'
}

export const STORES_SEARCH_CONTEXT = {
  PRODUCTS_SEARCH_STORE_PAGE: 'products_search_store_page',
  PRODUCTS_SEARCH_STORE_PAGE_DEFAULT: 'products_search_store_page_default',
  SEARCH_BAR_B2C: 'search_bar_b2c',
  SEARCH_BAR_RED_CARPET: 'search_bar_red_carpet',
  SEARCH_BAR_ENJOEIPRO: 'search_bar_enjoeipro',
  STORE_SEARCH: 'store_search',
  STORE_VIEWED: 'store_viewed',
  WELCOME_HOME_C2C_STORE: 'welcome_home_c2c_store',
  WELCOME_HOME_RED_CARPET_STORE: 'welcome_home_red_carpet_store',
  WELCOME_HOME_B2B_STORE: 'welcome_home_b2b_store',
  WELCOME_HOME_RED_CARPET: 'welcome_home_red_carpet',
  ENJOEI_PRO: 'home_enjoeipro'
}

export const PRODUCTS_CONTEXT = {
  MY_ENJOEI_BANNERS: 'my_enjoei_banners',
  MEU_ENJOEI_BANNERS: 'meu_enjoei_banners',
  MEU_ENJOEI_BAIXOU: 'meu_enjoei_baixou',
  MEU_ENJOEI_CONTINUE_COMPRANDO: 'meu_enjoei_continue_comprando',
  MEU_ENJOEI_MINHAS_OFERTAS: 'meu_enjoei_minhas_ofertas',
  MEU_ENJOEI_YEYEZADOS: 'meu_enjoei_yeyezados',
  MEU_ENJOEI_LOJINHAS_QUE_EU_SIGO: 'meu_enjoei_lojinhas_que_eu_sigo',
  MEU_ENJOEI_MARCAS_QUE_EU_SIGO: 'meu_enjoei_marcas_que_eu_sigo',
  MEU_ENJOEI_ULTIMOS_PRODUTOS_VISTOS: 'meu_enjoei_ultimos_produtos_vistos',
  MEU_ENJOEI_DESCONTOS: 'meu_enjoei_descontos',
  MINHALOJA_YEYEZADOS_PRODUTO: 'minhaloja_yeyezados_produto',
  MINHALOJA_SEGUIDORES_LOJA: 'minhaloja_seguidores_loja',
  MINHALOJA_SEGUIDORES_PRODUTO: 'minhaloja_seguidores_produto',
  MINHALOJA_SEGUIDORES_MAIS: 'minhaloja_seguidores_mais',
  MINHALOJA_SEGUINDO_LOJA: 'minhaloja_seguindo_loja',
  MINHALOJA_SEGUINDO_PRODUTO: 'minhaloja_seguindo_produto',
  MINHALOJA_SEGUINDO_MAIS: 'minhaloja_seguindo_mais',
  LOJA_YEYEZADOS_PRODUTO: 'loja_yeyezados_produto',
  LOJA_SEGUIDORES_LOJA: 'loja_seguidores_loja',
  LOJA_SEGUIDORES_PRODUTO: 'loja_seguidores_produto',
  LOJA_SEGUIDORES_MAIS: 'loja_seguidores_mais',
  LOJA_SEGUINDO_LOJA: 'loja_seguindo_loja',
  LOJA_SEGUINDO_PRODUTO: 'loja_seguindo_produto',
  LOJA_SEGUINDO_MAIS: 'loja_seguindo_mais',
  ENJOEI_PRO: 'home_enjoeipro'
}

function getContext(contexts, ref) {
  return ref && contexts[ref.toUpperCase()]
}

export function getProductSearchContexByRef(ref) {
  return getContext(PRODUCTS_SEARCH_CONTEXT, ref) || PRODUCTS_SEARCH_CONTEXT.PRODUCTS_SEARCH_DEFAULT
}

export function getStoreSearchContexByRef(ref) {
  return getContext(STORES_SEARCH_CONTEXT, ref) || STORES_SEARCH_CONTEXT.PRODUCTS_SEARCH_STORE_PAGE_DEFAULT
}

export function getProductContexByRef(ref) {
  return getContext(PRODUCTS_CONTEXT, ref)
}
